

exports.__esModule = true;

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var _index = require('xo-device-info/dist/index');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _index2 = require('xo-models/src/checkout/index');

var _index3 = require('xo-models/src/app/index');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _fbMessenger = require('../constants/fbMessenger');

var _fbMessenger2 = _interopRequireDefault(_fbMessenger);

var _index4 = require('../utils/index');

var _index5 = _interopRequireDefault(_index4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoMessengerPluginDirective', {

    tag: 'xo-messenger-plugin',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        },
        pluginType: {
            type: 'str',
            required: false
        }
    },

    resolve: {
        models: function models() {

            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                messengerIntegration: _index3.$MessengerIntegrationDataModel.instance().retrieve()
            };
        }
    },

    lifecycle: {
        populate: function populate() {
            var that = this;
            var isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();

            // BA was offered to user or not
            var fbBAShownFlag = window.localStorage.getItem(_fbMessenger2['default'].FB_BA_SHOWN_FLAG);

            // Added following flags to override usual behaviour to enable internal testing by FB and PYPL teams
            var overrideRepeatUserFlag = _squid.$util.param(_fbMessenger2['default'].OVERRIDE_FBPP_REPEAT_FLAG);

            _logger.$logger.info('Messenger_plugin_props', {
                'pluginType': this.props.pluginType,
                'isMobile': isMobile
            });
            _logger.$logger.info(isMobile ? 'messenger_mobile_tablet_traffic' : 'messenger_desktop_traffic');
            _logger.$logger.info('Messenger_plugin_data', this.models.messengerIntegration);

            var isChatPrefEnabled = this.models.messengerIntegration.isChatPrefEnabled;
            // if 'isChatPrefEnabled' variable is enabled, it means that user has already onboarded to messenger feature hence we don't trigger messenger onboarding for that user again

            if (overrideRepeatUserFlag) {
                // override isChatPrefEnabled and fbBAShownFlag
                _logger.$logger.info('override_repeat_user_flag_active');
            } else if (isChatPrefEnabled || fbBAShownFlag === 'true' && this.props.pluginType === 'STM') {
                _logger.$logger.info('UNP_chat_prefernce_is_already_enabled');
                (0, _jquery2['default'])('.fb-send-to-messenger').hide();
                (0, _jquery2['default'])('#stm-upsell-content').hide();
                return;
            }

            var txnId = void 0;
            var checkoutSession = this.models.checkoutSession;

            if (checkoutSession && checkoutSession.transactionDetails) {
                txnId = checkoutSession.transactionDetails.receipt_id || checkoutSession.transactionDetails.id;
            }
            var identityMatchJSON = {
                'email_hash': this.models.messengerIntegration.emailHash,
                'name_hash': this.models.messengerIntegration.nameHash
            };

            // Messenger plugin comparare this user ID hash with FB user 
            this.identityMatchVal = JSON.stringify(identityMatchJSON);
            this.dataRefVal = this.models.messengerIntegration.dataRefJWT + '_txnID_' + txnId + '_plugin_' + this.props.pluginType + '_token_' + this.props.token;
            this.originVal = window.location.origin;
            if (that.originVal.indexOf('qa.paypal.com') !== -1 || that.originVal.indexOf('localhost') !== -1 || that.originVal.indexOf('sandbox.paypal.com') !== -1) {
                this.pageIdVal = _fbMessenger2['default'].FB_TEST_PAGE_ID;
            } else {
                this.pageIdVal = _fbMessenger2['default'].FB_PROD_PAGE_ID;
            }

            this.generateUUID = function () {
                function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
                }
                return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
            };

            if (that.props.pluginType === 'CHECKBOX') {
                this.uuidVal = this.generateUUID();
                window.sessionStorage.checkboxUUIDVal = this.uuidVal;
            }

            _squid.$dom.loadScript('facebook-jssdk', 'https://www.paypalobjects.com/js/xo/fb_sdk.js').then(function () {
                if (window.FB) {
                    that.fbAsyncInit();
                    //  Note - Uncomment following on stage and localhost
                    // that.cbSTMPlugin({
                    //     event: 'identity_match',
                    //     ref: that.dataRefVal,
                    //     result: 'match'
                    // });
                }
            });

            this.cbSTMPlugin = function (evt) {
                var _this = this;

                // callback for events triggered by the STM plugin
                if (evt.event === 'rendered' && that.props.pluginType === 'STM') {
                    _logger.$logger.info('STM_plugin_rendered');
                }

                if (evt.event === 'identity_match' && evt.result === 'match' && that.props.pluginType === 'STM') {
                    _logger.$logger.info('FBPP_ID_match');
                    var pxpContext = _index5['default'].getMessengerPXPContext();
                    that.dataRefVal = evt.ref;

                    (0, _squid.$pxp)(_fbMessenger2['default'].PXP_MESSENGER_EXPT, pxpContext, _fbMessenger2['default'].PXP_SHOW_FB_BA_TREATMENT).then(function (result) {
                        _logger.$logger.info('Messenger_Plugin_PXP_RESULT', result);
                        if (result && result.treatment_name === _fbMessenger2['default'].PXP_SHOW_FB_BA_TREATMENT) {
                            _this.pxpMessengerBAIntegrationEnabled = true;
                            _jquery2['default'].ajax({
                                url: isMobile ? _fbMessenger2['default'].FB_USER_API_MOBILE_URL : _fbMessenger2['default'].FB_USER_API_URL,
                                xhrFields: {
                                    withCredentials: true
                                }
                            }).always(function (response) {
                                var responseText = response.responseText;
                                var json = responseText.substring(responseText.indexOf('{'));
                                var data = _jquery2['default'].parseJSON(json);
                                _logger.$logger.info('callFBToGetBAToken_call', data);
                                that.models.messengerIntegration.action('callFBToGetBAToken', {
                                    data: {
                                        userIdentifier: data.user_identifier
                                    },
                                    success: function success(fbresult) {
                                        if (fbresult.success) {
                                            (function () {
                                                _logger.$logger.info('BAToken_from_FB', {
                                                    'batoken': fbresult.batoken
                                                });
                                                var fbBAToken = fbresult.batoken,
                                                    BAUrl = void 0,
                                                    xoJSData = void 0;

                                                if (that.originVal.indexOf('localhost') !== -1) {
                                                    // Generate new FB Channel BA and update while testing, BA gets invalidated in few hours
                                                    fbBAToken = 'BA-0V626307R39449349';
                                                }
                                                if (that.originVal.indexOf('localhost') !== -1) {
                                                    BAUrl = 'http://localhost.paypal.com:8000/webapps/hermes/agreements/approve?ul=0&messenger_ba=1';
                                                    xoJSData = {
                                                        'data-env': 'local',
                                                        'data-stage': 'msmaster',
                                                        'data-no-bridge': ''
                                                    };
                                                } else if (that.originVal.indexOf('sandbox.paypal.com') !== -1 || that.originVal.indexOf('qa.paypal.com') !== -1) {
                                                    BAUrl = 'https://www.sandbox.paypal.com/agreements/approve?messenger_ba=1';
                                                    xoJSData = {
                                                        'data-env': 'sandbox',
                                                        'data-no-bridge': ''
                                                    };
                                                } else {
                                                    BAUrl = 'https://www.paypal.com/agreements/approve?messenger_ba=1';
                                                    xoJSData = {
                                                        'data-env': 'production',
                                                        'data-no-bridge': ''
                                                    };
                                                }
                                                if (overrideRepeatUserFlag) {
                                                    BAUrl = BAUrl + '&override_fbpp_repeat=1';
                                                }
                                                var launchBAFlow = function launchBAFlow() {
                                                    _logger.$logger.info('Launch_BA_flow_with_token', {
                                                        'fbBAToken': fbBAToken
                                                    });
                                                    _logger.$logger.info('Launch_BA_flow_with_URL', {
                                                        'BAUrl': BAUrl
                                                    });
                                                    window.ppxo.Checkout.contexts.lightbox = true;
                                                    window.localStorage.setItem(_fbMessenger2['default'].FB_BA_SHOWN_FLAG, 'true');
                                                    window.ppxo.Checkout.render({
                                                        url: BAUrl,
                                                        billingAgreement: fbBAToken,
                                                        onAuthorize: function onAuthorize(authorizedResponse) {
                                                            _logger.$logger.info('User_accepted_FB_BA');
                                                            if (window.sessionStorage.checkboxPluginState === 'unchecked') {
                                                                _logger.$logger.info('user_not_accepted_messenger_notifications');
                                                                (0, _jquery2['default'])('.fb-send-to-messenger').hide();
                                                                (0, _jquery2['default'])('#stm-upsell-content').hide();
                                                                (0, _jquery2['default'])('#ba-integration-content').show();
                                                            } else {
                                                                _logger.$logger.info('user_accepted_checkbox_messenger_notifications');
                                                                (0, _jquery2['default'])('.fb-send-to-messenger').hide();
                                                                (0, _jquery2['default'])('#stm-upsell-content').hide();
                                                                (0, _jquery2['default'])('#messenger-ba-integration-content').show();
                                                            }
                                                            that.confirmCheckboxPluginOptIn();
                                                            that.models.messengerIntegration.action('notifyFBOntBAAuthorize', {
                                                                data: {
                                                                    baToken: authorizedResponse.billingToken
                                                                },
                                                                success: function success(fbCallResult) {
                                                                    if (fbCallResult.success) {
                                                                        _logger.$logger.info('notifyFBOntBAAuthorize_call_success!');
                                                                    } else {
                                                                        _logger.$logger.info('notifyFBOntBAAuthorize_call_failure!');
                                                                    }
                                                                }
                                                            });
                                                        }
                                                    });
                                                };
                                                if (window.ppxo) {
                                                    _logger.$logger.info('xo_JS_is_already_present');
                                                    launchBAFlow();
                                                } else {
                                                    _squid.$dom.loadScript('xo-js', 'https://www.paypalobjects.com/api/paypal.checkout.v4.js', 0, xoJSData).then(function () {
                                                        _logger.$logger.info('xo_JS_got_loaded');
                                                        launchBAFlow();
                                                    });
                                                }
                                            })();
                                        } else {
                                            _logger.$logger.info('callFBToGetBAToken_call_failure!');
                                        }
                                    }
                                });
                            });
                        } else {
                            _logger.$logger.info('no_pxp_for_ba');
                            _this.pxpMessengerBAIntegrationEnabled = false;
                        }
                    });
                } else if (evt.event === 'identity_match' && evt.result === 'no_match' && that.props.pluginType === 'STM') {
                    _logger.$logger.info('No_FBPP_ID_match');
                } else if (evt.event === 'identity_match' && evt.result === 'no_logged_in_user' && that.props.pluginType === 'STM') {
                    _logger.$logger.info('No_loggedin_FBPP_ID_match');
                } else if (evt.event === 'identity_match' && evt.result === 'failure' && that.props.pluginType === 'STM') {
                    _logger.$logger.info('Fail_FBPP_ID_match');
                } else if (evt.event === 'clicked' && that.props.pluginType === 'STM') {
                    _logger.$logger.info('user_accepted_STM_messenger_notifications');
                }
            };
            this.fbAsyncInit = function () {
                _logger.$logger.info('Initializing_FB_scripts');
                window.FB.init({
                    appId: _fbMessenger2['default'].FB_PROD_APP_ID,
                    xfbml: true,
                    version: 'v2.6'
                });
                // Subscribe to STM
                window.FB.Event.subscribe('send_to_messenger', this.cbSTMPlugin);

                // Subscribe to CHECKBOX
                window.FB.Event.subscribe('messenger_checkbox', function (evt) {
                    _logger.$logger.info('messenger_checkbox_event', evt);
                    if (evt.event === 'checkbox') {
                        window.sessionStorage.checkboxPluginState = evt.state;
                        _logger.$logger.info('checkbox_plugin_state_' + that.checkboxPluginState);
                    }
                });
            };

            this.confirmCheckboxPluginOptIn = function () {
                _logger.$logger.info('MessengerCheckboxPluginUserConfirmation_event_to_fb', {
                    'uuidVal': window.sessionStorage.checkboxUUIDVal,
                    'pageIdVal': this.pageIdVal,
                    'dataRefVal': this.dataRefVal
                });
                window.FB.AppEvents.logEvent('MessengerCheckboxUserConfirmation', null, {
                    'page_id': this.pageIdVal,
                    'app_id': _fbMessenger2['default'].FB_PROD_APP_ID,
                    'ref': this.dataRefVal,
                    'user_ref': window.sessionStorage.checkboxUUIDVal
                });
            };
        },
        exit: function exit() {
            _logger.$logger.info('Messenger_plugin_EXIT_event');
        }
    }
});

_logger.$logger;

_squid.$Component;

_squid.$pxp;

_squid.$dom;

_squid.$util;

_index.$DeviceInfo;

_index2.$CheckoutSessionModel;

_index3.$MessengerIntegrationDataModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/messenger-plugin/directive.js
// module id = ./components/xo-page-components/src/messenger-plugin/directive.js
// module chunks = 1